module.exports = __webpack_public_path__ + "static/media/pizza.4c50647e.png";